import { createContext, useState } from 'react'
export interface LoaderContextProps {
    load: boolean
    setLoad: any
    head: boolean
    setHead: any
}

const LoaderContext = createContext<LoaderContextProps>({} as LoaderContextProps)

const LoaderProvider = ({ children }) => {
  const [load, setLoad] = useState(false)
  const [head, setHead] = useState(true)

  const data = {
    load,
    setLoad,
    head, 
    setHead
  }

  return <LoaderContext.Provider value={data}>{children}</LoaderContext.Provider>
}

export { LoaderProvider, LoaderContext }